import imageSliderService from "../services/image-slider.service"
import {  CREATE_VIDEOS, DELETE_VIDEO, FETCH_VIDEOS,  UPDATE_VIDEO,  VIDEOS_FAIL, VIDEOS_SUCCESS } from "./type"

export const fetchVideos = (reference) => (dispatch) =>{
    dispatch({type:FETCH_VIDEOS})
    imageSliderService.getImages(reference).then((response)=>{
        const parsedVideos =  response.map((el)=>{
            const byteString = window.atob(el.data.split(',')[1]);
            // const mimeString = el.data.split(',')[0].split(':')[1].split(';')[0];
     
               const ab = new ArrayBuffer(byteString.length);
               const ia = new Uint8Array(ab);
               for (let i = 0; i < byteString.length; i++) {
                 ia[i] = byteString.charCodeAt(i)
               }
               
               const dataBlob = new Blob([ab], { type: "video/mp4" })
               const urlVideo = URL.createObjectURL(dataBlob)
               return{url: urlVideo, name: el.name}
               })
        dispatch({type:VIDEOS_SUCCESS,payload:parsedVideos})
        return Promise.resolve()
    },
    (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VIDEOS_FAIL,
          payload: message,
        });
  
        return Promise.reject(error);
      }
    );
  };
  

  export const createVideos = (is_image, video ) => (dispatch) =>{
    return imageSliderService.uploadImage(video, is_image).then((response)=>{
      dispatch({type:CREATE_VIDEOS, payload:response})
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

        dispatch({
          type: VIDEOS_FAIL,
          payload: message,
        });

      return Promise.reject(error);
    }
  );
};

export const deleteVideoDispatch = (is_image, video ) => (dispatch) =>{
 return imageSliderService.deleteImage(video,is_image).then((response)=>{
    dispatch({type:DELETE_VIDEO, payload:response})
    return Promise.resolve();
  },
  (error) => {
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();

      dispatch({
        type: VIDEOS_FAIL,
        payload: message,
      });

    return Promise.reject(error);
  }
);
};
export const updateVideo = ( video, is_image ) => (dispatch) =>{
  
  return imageSliderService.updateImage(video,is_image).then((response)=>{
    dispatch({type:UPDATE_VIDEO, payload:response})
    return Promise.resolve();
  },
  (error) => {
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();

      dispatch({
        type: VIDEOS_FAIL,
        payload: message,
      });

    return Promise.reject(error);
  }
);
};